import {
	API_GET_ALL_DOCUMENT_TYPE,
	API_GET_ALL_DOCUMENT_TYPE_SUCCESS,
	API_GET_ALL_DOCUMENT_TYPE_FAIL,
	API_GET_DOCUMENT_TYPE_BY_NAME,
	API_GET_DOCUMENT_TYPE_BY_NAME_FAIL,
	API_GET_DOCUMENT_TYPE_BY_NAME_SUCCESS,
} from '../actions/documentType';
import { createReducer } from '@reduxjs/toolkit';
import { errorHandler, ErrorAction } from 'utils/error';

const initialState = {
    loading: false,
	list: [],
	type: null,
};

const documentTypes = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_DOCUMENT_TYPE]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_DOCUMENT_TYPE_FAIL]: (state, action) => {
		errorHandler('Type de document', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_DOCUMENT_TYPE_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},
	[API_GET_DOCUMENT_TYPE_BY_NAME]: (state, action) => {
		state.loading = true;
	},
	[API_GET_DOCUMENT_TYPE_BY_NAME_FAIL]: (state, action) => {
		state.type = null;
		state.loading = false;
	},
	[API_GET_DOCUMENT_TYPE_BY_NAME_SUCCESS]: (state, action) => {
		state.loading = false;
		state.type = action.payload.data;
	},
});

export default documentTypes;
